export default __webpack_public_path__ + "static/media/text-field-valid-feedback.b560b0b8.svg";